module.exports = __webpack_public_path__ + "img/geofisica2_4-3_1024.4fe12c24.jpg";